import React, { useEffect, useState } from 'react'
import { motion } from 'framer-motion';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router';
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import { useSelector } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';
import '../../style/Plans/_newPlan.scss'

import {ReactComponent as LogoWhite} from '../../assets/img/logo_esteso_wh.svg';
import {ReactComponent as Check} from '../../assets/new-icons/check_simple.svg';
import md5 from 'md5';
import axios from 'axios';
import { useFetchLoginGas } from '../../functions/loginGas';

function RicaricaEffettuata() {
    const navigate = useNavigate()
    const currentPlan = useSelector((user) => user?.user?.idGruppo)
    const [showScroll, setShowScroll] = useState(false)
    const customerId = useSelector((user) => user.user.info.customer_id);
    const tkn = md5(customerId + 'oYmAIdtki%lu') 
    const customerIdGas = useSelector((user) => user?.gas?.info?.customer_id);
    const tknGas = md5(customerIdGas + 'oYmAIdtki%lu') 
    const customerCodeGas = useSelector((user) => user?.gas?.info?.customer_code);
    const customerCode = useSelector((user) => user.user.info.customer_code);
    const [dataRicarica, setData] = useState()
    const token = useSelector((user) => user.user.datiPagamento.token)
    const iban = useSelector((user) => user.user.datiPagamento.account_iban)
    const defaultMethod = useSelector((user) => user.user.payMethodDefault)
    const section = useSelector((user) => user.settings.section)
    const fetchLogin = useFetchLoginGas()

    const checkScrollTop = () => {
        if (!showScroll && window.pageYOffset > 120){
          setShowScroll(true)
        } else if (showScroll && window.pageYOffset <= 120){
            setShowScroll(false)
        }
    };
    const scrollTop = () =>{
        window.scrollTo({top: 0, behavior: 'smooth'});
    };
    window.addEventListener('scroll', checkScrollTop)

    const bodyBox = {
        initial: {
            height: 0,
            bottom: -150,
            transition: {
                duration: 1.0,
                ease: [0.87, 0, 0.13, 1]
            }
        },
        animate: {
            height: '90%',
            bottom: -150,
            transition: {
                duration: 1.0,
                ease: [0.87, 0, 0.13, 1]
            }
        }
    };
    useEffect(() => {
        section ? initGas() : initEn()
    },[])
    const initEn = async () => {
        const movementsApi = `https://my.revoluce.it/area_utente/gestione/api/deliveries/getMovimentazioni.php?customer_id=${customerId}&customer_code=${customerCode}&tkn_pvt=${tkn}`
        const { data } = await axios.get(movementsApi)
        const lastItem = data.result.reverse()[0]
        setData(lastItem)
    }
    const initGas = async () => {
        const movementsApiGas = `https://my.revoluce.it/area_utente/gestione/api/deliveries/getMovimentazioniGas.php?customer_id=${customerIdGas}&customer_code=${customerCodeGas}&tkn_pvt=${tknGas}`
        const { data } = await axios.get(movementsApiGas);
        const lastItem = data.result.reverse()[0]
        setData(lastItem)
    }   
    const handleGas = () => {
        console.log(customerCodeGas)
        fetchLogin(customerCodeGas)
        navigate('/enrica/gas')
        
    }
    return (
        <div className='newPlan green'>
            <div className="newPlan-top">
                <header>
                    <div className="logo">
                        <LogoWhite />
                    </div>
                </header>
                <div className="text">
                    <p className="main">Ricarica effettuata.</p>
                </div>
            </div>
            <div className="newPlan-bottom">
                <div className="boxSwipe">
                    <p className="labelSwipe">Perfetto</p>
                    <div className="icon">
                        <Check className="check" />
                    </div>
                </div>
                <div className="recapInfo">
                    <p className="main">
                        Ricarica effettuata
                    </p>
                        {dataRicarica ? (
                            <p className='secondary'>
                                Abbiamo ricaricato {dataRicarica && parseFloat(dataRicarica.amount).toFixed(2).replace(/\./g, ',')} dal metodo di pagamento da te selezionato che termina con:  {defaultMethod && defaultMethod === 'RID' ? iban.slice(iban.length - 4) : token.slice(token.length - 4)}.
                            </p>
                    ) : <CircularProgress />}
                    <div className="buttonBox">
                        <button onClick={() => section ? navigate("/enrica/gas")  : navigate("/enrica")}>
                            <p>Home</p>
                            <ArrowForwardIos />
                        </button>
                        <button onClick={() => navigate('/enrica/movimenti')}>
                            <p>Tutti i movimenti</p>
                            <ArrowForwardIos />
                    </button>
                    </div>
                </div>
            </div>
        </div>
        // <div className='newPlan' onClick={() => scrollTop}>
        //     <motion.div
        //         initial="initial"
        //         animate="animate"
        //         className={`header 
        //             green
        //             ${showScroll ? 'fixed' : ''}
        //         `}
        //     >
        //         <div className="navigation">
        //             <LogoWhite onClick={() => navigate(-1)}/>
        //         </div>
        //         {!showScroll && (
        //             <div className="information">
        //                 <div className="planName epilogue">
        //                     <p>Complimenti!</p>
        //                 </div>
        //                 <div className="planSub epilogue">
        //                     <p>Ricarica avvenuta.</p>
        //                 </div>
        //             </div>
        //         )}
        //     </motion.div>
        //     <motion.div
        //         initial="initial"
        //         animate="animate"
        //         variants={bodyBox}
        //         className={`body ${showScroll ? 'noBorder' : ''}`}
        //     >
        //        <div className="boxSwipe">
        //            <p className="labelSwipe">Perfetto</p>
        //            <div className="icon">
        //                <Check className='check'/>
        //            </div>
        //        </div>
        //        <div className="recapInfo">
        //            <p className="main">
        //               Ricarica effettuata
        //            </p>
        //            {dataRicarica ? (
        //                 <p className='secondary'>
        //                     Abbiamo ricaricato {dataRicarica && parseFloat(dataRicarica.amount).toFixed(2).replace(/\./g, ',')} dal metodo di pagamento da te selezionato che termina con:  {defaultMethod && defaultMethod === 'RID' ? iban.slice(iban.length - 4) : token.slice(token.length - 4)}.
        //                 </p>
        //            ) : <CircularProgress />}
                  
        //             <p className='secondary'>Stiamo elaborando le modifiche e a breve potrai visualizzare la situazione della tua utenza aggiornata.</p>
        //        </div>
        //        <p className="label">
        //            Nel frattempo, ecco alcuni suggerimenti revoluzionari che abbiamo scelto per te:
        //        </p>
        //        <div className="buttonBox">
        //            <button onClick={() => section ? handleGas() : navigate('/enrica')}>
        //               <p>Home</p>
        //               <ArrowForwardIos />
        //            </button>
        //            <button onClick={() => section ? navigate('/enrica/gas/movimenti') : navigate('/enrica/movimenti')}>
        //                 <p>Tutti i movimenti</p>
        //                 <ArrowForwardIos />
        //            </button>
        //        </div>
        //     </motion.div>
        // </div>
    )
}

export default RicaricaEffettuata
